import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Loader2, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { impersonation, stopImpersonating } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!impersonation) return null;

  const onExit = async () => {
    setExiting(true);
    await stopImpersonating();
    navigate("/admin/users", { replace: true });
  };

  return (
    <div
      className="sticky top-16 z-20 flex flex-wrap items-center justify-between
                 gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm
                 font-medium text-amber-900 dark:border-amber-800
                 dark:bg-amber-950 dark:text-amber-200"
    >
      <div className="flex items-center gap-2">
        <Shield className="h-4 w-4 flex-none" />
        <span>
          Admin mode · Viewing{" "}
          <b>{impersonation.targetUserName || impersonation.targetUserEmail}</b>
          <span className="ml-2 hidden text-amber-700 dark:text-amber-400 sm:inline">
            ({impersonation.adminEmail})
          </span>
        </span>
      </div>
      <button
        onClick={onExit}
        disabled={exiting}
        className="inline-flex items-center gap-1.5 rounded-md bg-amber-900 px-3 py-1 text-xs
                   font-semibold text-white hover:bg-amber-800 disabled:opacity-60"
      >
        {exiting ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <LogOut className="h-3.5 w-3.5" />
        )}
        Exit admin mode
      </button>
    </div>
  );
}
